import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';
import { isTokenValid } from "../Start";
import './login.css';

// Use same-origin API base in production; dev is proxied via package.json
const API_URL = process.env.REACT_APP_API_URL || "";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && isTokenValid(token)) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");

    const formData = new URLSearchParams();
    formData.append("username", DOMPurify.sanitize(username));
    formData.append("password", DOMPurify.sanitize(password));

    try {
      const res = await fetch(`${API_URL}/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      if (!res.ok) {
        setError("Invalid username or password");
        return;
      }
      const data = await res.json();
      localStorage.setItem("token", data.access_token);
      navigate("/");
    } catch {
      setError("Network error");
    }
  }

  return (
    <div 
      className="login-page"
      style={{
        backgroundImage: 'url(/Login.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="login-container">
        <div className="login-right">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-header">
              <h1 className="login-main-title">
                <i className="bi bi-hospital me-2"></i>
                Psychiatrist
              </h1>
              <p className="login-sub-title">Admin Login</p>
            </div>

            <div className="input-group">
              <span className="input-icon">
                <i className="bi bi-person"></i>
              </span>
              <input
                id="username"
                className="login-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Username"
              />
            </div>

            <div className="input-group">
              <span className="input-icon">
                <i className="bi bi-lock"></i>
              </span>
              <input
                id="password"
                className="login-input"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
            </div>

            <button type="submit" className="login-button">
              Log In
            </button>

            {error && <p className="login-error">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
